import { useState, useEffect } from 'react';
import { Box, FormControl, Grid, TextField } from '@mui/material';
import SelectGroupProvider from '../../../../../dsasComponents/SelectGroupProvider.js';
import { getUserProvider, isAdminDSAS } from '../../../../../actions/auth.js';
import DateTimePicker_Dsas from '../../../../../dsasComponents/DateTimePicker_Dsas.js';
import SelectMultiUser from '../../../../../dsasComponents/SelectMultiUser.js';
import useStyles from '../../../../../styles/global-mui.js';
import DsasButton from '../../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { usePermissions } from '../../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';
import { useSelector } from 'react-redux';

const Step1 = ({ state, setState, onSubmit, isEditMode }) => {
  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

  const classes = useStyles();

  const provider = state.provider ?? '';
  const name = state.name ?? '';
  const dateTime = state.dateTime ?? null;
  const userNames = state.userNames ?? [];

  const setField = (patch) => setState((s) => ({ ...s, ...patch }));

  const handleNext = () => {
    onSubmit({ name, provider, dateTime, userNames });
  };

  const isNextDisabled = !name || !dateTime || !provider;

  return (
    <>
      <Grid container spacing={1.5}>
        <Grid item xs={12}>
          <TextField
            className={classes.customInput}
            id="name"
            label="Nom du direct"
            variant="standard"
            margin="normal"
            fullWidth
            value={name}
            onChange={(e) => setField({ name: e.target.value })}
            error={!name}
            helperText={!name ? 'Veuillez saisir un nom de direct.' : ''}
          />
        </Grid>
      </Grid>

      <Box className="medium-padding" />

      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={3} md={3}>
          <DateTimePicker_Dsas
            fullwidth
            className={classes.customInput}
            label="Début du direct"
            name="dateTime"
            value={dateTime}
            onChange={(v) => setField({ dateTime: v })}
          />
        </Grid>

        {providerPermission?.allowed && (
          <Grid item xs={12} sm={3} md={3}>
            <FormControl
              fullWidth
              className={classes.customInput}
              variant="standard"
              margin="normal"
              sx={{ marginTop: 0 }}
            >
              <SelectGroupProvider
                value={provider}
                onChange={(e) => {
                  const newProvider = e.target.value;
                  // reset des users quand le provider change
                  setField({ provider: newProvider, userNames: [] });
                }}
              />
            </FormControl>
          </Grid>
        )}

        <Grid item xs={12} sm md>
          <SelectMultiUser
            className={classes.customInput}
            provider={provider}
            usersSelected={userNames}
            handleChangeUsers={(users) => setField({ userNames: users })}
          />
        </Grid>
      </Grid>

      <Box className="medium-padding" />
      <Box className="medium-padding" />
      <Box className="large-separator" />

      {!isEditMode && (
        <Box className="padding-wrapper display-grid">
          <DsasButton
            onClick={handleNext}
            icon={faArrowRight}
            label="Etape suivante"
            variant="alternative"
            disabled={isNextDisabled}
            customCss={{
              width: '170px',
              justifySelf: 'right',
              display: 'flex',
              flexDirection: 'row-reverse',
              flexWrap: 'nowrap',
              alignContent: 'flex-start',
              justifyContent: 'space-evenly',
              alignItems: 'center',
            }}
          />
        </Box>
      )}
    </>
  );
};

export default Step1;